<template>
  <div class="ProjectEdit__part">
    <violet-bar>Labels et spécificités</violet-bar>
    <help-message>
      <h3 slot="title">Labels, spécificités</h3>
      <p>
        Le fonctionnement est identique à tous les champs de saisie
        prédictive.<br />Le champ "publications" est encore à préciser.
      </p>
    </help-message>
    <div class="squarebox">
      <div class="columns is-multiline">
        <div class="column is-one-third">
          <vertical-field>
            <label for="" class="label" slot="label">Labels</label>
            <kv-suggestor-multiple
              :items="project.labels"
              @update="project.labels = $event"
              :type="'labels'"
            ></kv-suggestor-multiple>
          </vertical-field>
          <vertical-field>
            <label for="" class="label" slot="label">Récompenses</label>
            <kv-suggestor-multiple
              :items="project.awards"
              @update="project.awards = $event"
              :type="'awards'"
            ></kv-suggestor-multiple>
          </vertical-field>
        </div>
        <div class="column is-one-third">
          <vertical-field>
            <label for="" class="label" slot="label">Normes</label>
            <kv-suggestor-multiple
              :items="project.normes"
              @update="project.normes = $event"
              :type="'normes'"
            ></kv-suggestor-multiple>
          </vertical-field>
          <disabled-thing>
            <vertical-field>
              <label for="" class="label" slot="label">Publications</label>
              <kv-suggestor-multiple
                :items="project.publications"
                @update="project.publications = $event"
                :type="'publications'"
              ></kv-suggestor-multiple>
            </vertical-field>
          </disabled-thing>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DisabledThing from "../../../components/Form/DisabledThing";
import KvSuggestorMultiple from "../../../components/Form/KvSuggestorMultiple";
import VerticalField from "../../../components/Form/VerticalField";
import VioletBar from "../VioletBar";
import HelpMessage from "../../../components/Form/HelpMessage";

export default {
  name: "ProjectEdit-Specificities",
  components: {
    HelpMessage,
    DisabledThing,
    KvSuggestorMultiple,
    VerticalField,
    VioletBar
  },
  props: {
    item: {}
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  }
};
</script>
